import { ModalService } from './../../../../shared/services/modal.service';
import { Component, OnInit, Input } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { map, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ErrorHandlerService } from 'src/app/shared/services/error-handler.service';
import { PurchaseOrderService } from 'src/app/services/purchase-order/purchase-order.service';
import { ShipmentsModalComponent } from './shipments-modal/shipments-modal.component';

@Component({
  selector: 'purchase-order',
  templateUrl: './purchase-order.component.html',
  styleUrls: ['./purchase-order.component.scss']
})
export class PurchaseOrderComponent implements OnInit {
  public loading: boolean = false;
  public purchaseOrders: any = [];
  public totalPurchaseOrders: number = 0;
  public currentPage: any;
  public currentSortProperty: string;
  public currentSortDirection: string;
  private _searchSubscription: Subscription;
  public filter: any = {
    filters: {
      query_text: ''
    },
    supplierId: '',
    page: 1,
    limit: 10,
    meta: true
  };

  @Input() supplierId: string;

  constructor(
    public _purchaseOrder: PurchaseOrderService,
    private _errorHandlerService: ErrorHandlerService,
    private _modalService: ModalService) { }

  async ngOnInit() {
    this._loadPurchaseOrder();
  }

  ngAfterViewInit() {
    this._setupSearch();
  }

  /**
   * Refreshes data from api of current page
   * @param pageNumber
   */
  public pageChange(pageNumber: number): void {
    this.filter.page = pageNumber;
    this.currentPage = pageNumber;
    this.filter.filters.query_text = (document.getElementById("input-search-po") as HTMLElement)['value'];
    this._loadPurchaseOrder();
  }

  /**
   * Load suppliers with current sorting, pagination and search text
   */
  private _loadPurchaseOrder(): void {
    this.loading = true;
    this.filter.supplierId = this.supplierId;
    this._purchaseOrder.getFilteredPurchaseOrders(this.filter).then((result: any) => {
      this.purchaseOrders = result.data || [];
      this.totalPurchaseOrders = result.meta.total || 0;
      this.loading = false;
    }).catch(err => {
      this._errorHandlerService.handleError(err, 'Error while filtering Purchase Orders!!');
      this.loading = false;
    })
  }

  /**
   * Setup Purchase Order search
   * Observes the element with id "searchText"
   * Waits 500 milliseconds before it sends filter request to back end
   */
  private _setupSearch(): void {
    this._searchSubscription = Observable.fromEvent(document.getElementById('input-search-po'), 'input').pipe(
      map((e: KeyboardEvent) => {
        let element = e.target as HTMLInputElement;
        let value = element.value;
        return value;
      }),
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe((searchText: any) => {
      this.filter.filters.query_text = searchText.trim();
      this._loadPurchaseOrder();
    });
  };

  /**
   * Unsubscribe search subscription
   */
  ngOnDestroy(): void {
    this._searchSubscription.unsubscribe();
  }

  /**
   * Open Modal to show released shipents for POLine
   * @param release_history
   * @param po_line_number
   */
  public openPOShipsModal(release_history: any[], po_line_number: string): void {
    this._modalService.open(ShipmentsModalComponent, {releaseHistory: release_history, poLineNumber: po_line_number }, { width: '400px' });
  }
}
